import { userPermission } from "constants/permissions/userPermission";
import { userAgentViewPermission } from "constants/permissions/userAgentPermission";
import { configCiPermission } from "constants/permissions/configCiPermission";
import { publishRequestPermission } from "constants/permissions/publishRequestPermission";
import { initialScrapeTaskPermission } from "constants/permissions/initialScrapeTaskPermission";
import { brandPermission } from "constants/permissions/brandPermission";
import { branchPermission } from "constants/permissions/branchPermission";
import { configPermission } from "constants/permissions/configPermission";
import { rolePermission } from "constants/permissions/rolePermission";
import { blockSelector } from "constants/permissions/blockSelector";
import { trackerPermission } from "constants/permissions/trackerPermission";
import { menuItemsPermission } from "constants/permissions/menuItemsPermission";
import { metricsPermission } from "constants/permissions/metrics";
import { credentialsPermission } from "constants/permissions/credentials";
import { credentialsTypesPermission } from "constants/permissions/credentialsTypes";
import { proxiesPermission } from "constants/permissions/proxies";
import { primaryKeyConfigsPermission } from "constants/permissions/primaryKeyConfigsPermission";
import {siteGroupsPermission} from "./siteGroupsPermission";
import {brandTrackedDomainsPermission} from "./brandTrackedDomainsPermission";
import {quotaLimitsPermission} from "./quotaLimits";
import {queuesPermission} from "./queuesPermission";
import {initialScrapeTaskBatchStartViewPermission} from "./initialScrapeTaskBatchStartPermission";

export const PERMISSIONS = {
    ...menuItemsPermission,
    ...userPermission,
    ...userAgentViewPermission,
    ...initialScrapeTaskBatchStartViewPermission,
    ...publishRequestPermission,
    ...configCiPermission,
    ...initialScrapeTaskPermission,
    ...brandPermission,
    ...branchPermission,
    ...configPermission,
    ...rolePermission,
    ...blockSelector,
    ...trackerPermission,
    ...metricsPermission,
    ...quotaLimitsPermission,
    ...credentialsPermission,
    ...credentialsTypesPermission,
    ...proxiesPermission,
    ...primaryKeyConfigsPermission,
    ...siteGroupsPermission,
    ...brandTrackedDomainsPermission,
    ...queuesPermission,
    countryView: "country.view",
    tenantView: "tenant.view",
    apidocView: "apidoc.view",
    dataSelectorActionView: "data-selector-action.view",
    dataSelectorTypeView: "data-selector-type.view",
    dataSelectorConditionTypeView: "data-selector-condition-type.view",
    sourceView: "source.view",
    statusView: "status.view",
    statusTypeView: "status-type.view",
    templateSelectorTypeView: "template-selector-type.view",
    templateSelectorSourceView: "template-selector-source.view",
    templateSelectorConditionView: "template-selector-condition.view",
    normalizerView: "normalizer.view",
    receiverView: "receiver.view",
    responseProviderView: "response-provider.view",
    proxyTypeView: "proxy-type.view",
    retryRuleTypeView: "retry-rule-type.view",
    retryRuleActionView: "retry-rule-action.view",
    objectStructuresView: "object-structures.view",
    processViewProgress: "process.view-progress",
    selectorSpeedTestTest: "selector-speed-test.test",
    objectStructureUpdate: "object-structure.update",
    validatorsForObjectPropertiesView: "validators-for-object-properties.view",
    validatorsForObjectView: "validators-for-object.view",
    authPolicyDefinitionsView: "auth-policy-definitions.view"
};
